import React from 'react'

export function ThemeHeading(props) {
    return (
        <div className="site-heading text-center">
            <h2>{props.heading}</h2>
        </div>
    )
}